import React, { useState, useEffect } from 'react';
import { create } from 'apisauce';
import { getAuthToken } from 'utils/cookies';
import { SchedulerEditor } from 'components/Scheduler';

const Scheduler = () => {
  const [configurationId, setConfigurationId] = useState(null);

  const getIntegrationConfig = async () => {
    const token = getAuthToken();

    const api = create({
      baseURL: `${process.env.REACT_APP_AP_URL}`,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Authorization': `Bearer ${token}`,
      },
    });
    try {
      const response = await api.get('/api/integrations/get-configs', {});

      if (response && response.data && Array.isArray(response.data) && response.data.length > 0) {
        // #TODO: the response from this endpoint returns all configurations, but we will default to the first
        // for now until we figure out how we want to display other configurations.
        setConfigurationId(response.data[0].id);
      }
      else {
        setConfigurationId(0);
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
    }
  };

  useEffect(() => {
    getIntegrationConfig();
  }, []);

  return (
    <SchedulerEditor configurationId={configurationId} />
  );
};

export default Scheduler;
